import { io, Socket } from "socket.io-client";
import { config } from "../../config";

//TODO: adjust clientUUID because the naming is likely innacurate regarding true intent
export class SocketService {
  private socket: Socket | null = null;
  private clientUUID: string | null = null;

  constructor(clientUUID: string | null) {
    this.clientUUID = clientUUID;
  }

  public initializeSocket(
    fetchPersonalOfferCallback: () => Promise<any>,
    captureUrlParametersCallback: () => void,
    registerClientCallback: () => void
  ): Socket | null {
    this.socket = io(
      config.socket.url || `http://localhost:${config.socket.port}`,
      {
        transports: ["websocket", "polling"],
        withCredentials: true,
        reconnection: true,
        reconnectionAttempts: config.socket.reconnectionAttempts,
        reconnectionDelay: config.socket.reconnectionDelay,
        auth: this.clientUUID ? { uuid: this.clientUUID } : undefined,
      }
    );

    if (!this.socket) return null;

    // Add connection event listeners
    this.socket.on("connect", () => {
      if (config.env === "development") {
        console.debug(
          "MonitoringService: Successfully connected to dashboard, Socket ID:",
          this.socket?.id
        );
      }

      // Fetch personal offer to show in modal
      fetchPersonalOfferCallback();

      // Continue with other URL parameter capture
      captureUrlParametersCallback();
    });

    this.socket.on("request_register_client", () => {
      console.log("MonitoringService: Received request to register client");
      registerClientCallback();
    });

    // Add reconnect event listener
    this.socket.on("reconnect", () => {
      console.log("MonitoringService: Reconnected to dashboard");
      // Re-register on reconnect
      registerClientCallback();
    });

    this.socket.on("connect_error", (error) => {
      console.error("MonitoringService: Connection error:", error);
      // TODO: send error to server
    });

    // Verify socket connection
    this.socket.on("disconnect", (reason) => {
      console.log(
        "MonitoringService: Disconnected from dashboard. Reason:",
        reason
      );
      //TODO: send disconnect event to server
    });

    // Listen for dashboard commands
    this.socket.on("dashboard_command", (command) => {
      console.log("MonitoringService: Received dashboard command:", command);
      // Handle different types of commands
      switch (command.type) {
        case "test_connection":
          console.log("Dashboard Connection Test Successful!", command.data);
          break;
        case "toggle_chatbot":
          console.log(
            "MonitoringService: Handling toggle_chatbot command:",
            command
          );
          // Forward the command to any registered callbacks
          this.socket?.emit("event_received", "toggle_chatbot");
          break;
        default:
          console.log("Unknown dashboard command:", command);
      }
    });

    // Add acknowledgment callback to verify event reception
    this.socket.on("event_received", (eventName) => {
      console.log(
        "MonitoringService: Dashboard acknowledged receipt of event:",
        eventName
      );
    });

    return this.socket;
  }

  public getSocket(): Socket | null {
    return this.socket;
  }

  public disconnect(): void {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}
